import {
  EDIT_CAMPAIGN_MUTATION_KEY,
  IAddCampaignResponse,
  editCampaign,
} from '@/modules/study-insights/services/campaign/campaign';
import { AddCampaignFormStringValues } from '../../AddCampaignForm/AddCampaignForm.types';
import { ContextOptions, MutationFunction, UseMutationResult, useMutation } from '@tanstack/react-query';

interface IUseAddCampaign {
  onSuccess?: () => void;
  onError?: (err: any) => void;
}

export const useEditCampaign = ({
  onError,
  onSuccess,
}: IUseAddCampaign): UseMutationResult<IAddCampaignResponse, unknown, AddCampaignFormStringValues, ContextOptions> => {
  const mutationFn: MutationFunction<IAddCampaignResponse, AddCampaignFormStringValues> = async (
    campaignValues: AddCampaignFormStringValues,
  ): Promise<IAddCampaignResponse> => {
    return await editCampaign(campaignValues);
  };

  return useMutation<IAddCampaignResponse, unknown, AddCampaignFormStringValues, ContextOptions>(
    [EDIT_CAMPAIGN_MUTATION_KEY],
    mutationFn,
    {
      onSuccess,
      onError,
    },
  );
};
